export default __webpack_public_path__ + "static/media/home-icon-active.18735ff0.webp";